<template>
  <div class="selected">
    <el-row>
      <el-col :span="24">
        <el-select
          size="small"
          clearable
          :multiple="!isRadio"
          remote
          default-first-option
          filterable
          :style="{width: `calc(${setWidth} - 45px)`,'vertical-align':'middle'}"
          v-model="insIds"
          :loading="loading"
          placeholder="请选择机构组织"
          :remote-method="remoteMethod"
          @change="getPost"
          @clear="reset"
        >
          <el-option
            v-for="item in options"
            :key="item.Type+'_'+item.SocialId"
            :label="item.Name"
            :value="item.Type+'_'+item.SocialId"
          >
            <span>{{ item.Name }}</span>
          </el-option>
        </el-select><el-button
          style="width:45px;display:inline-block;vertical-align:middle;"
          size="small"
          icon="el-icon-plus"
          :disabled="addBtn"
          @click="openDialog"
        ></el-button>
      </el-col>
    </el-row>
    <InstitutionDialog ref="insDialog" :isRadio="isRadio" @assignmentInput="assignmentInput"></InstitutionDialog>
  </div>
</template>

<script>
import {
  GetTemplateCompanyDeptSearchResult,
  AddTemplateSearchLog,
  GetTemplateCompanyDeptSearchByCount
} from "@/api/modules/basicData/organization";
import InstitutionDialog from "./InstitutionDialog";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  name: "selectedInstitution",
  components: {
    InstitutionDialog
  },
  data() {
    return {
      insList:[],//所有机构组织
      insIds: [],//选中的机构组织Key值，这里为：insId
      selectedIns: [],  //选中的机构组织集合
      loading: false,
      options: [],  //下拉框显示的机构组织
      addBtn: false,
      
      lastSelectedInsIds: [],
      category: 13
    };
  },
  props: {
    isRadio: {
      type: Boolean,
      default: false
    },
    setWidth: {
      type: String,
      default: "250px"
    },
    idArray: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  watch:{
    idArray(newValue,oldValue){
      console.log('newValue:',newValue,"oldValue:",oldValue);
      this.insIds = [];
      this.selectedIns = [];

      for(let id of newValue){
        let exist = this.insList.find(res => res.InsId == id);
        if (exist) {
          let exist_1 = this.selectedIns.find(s=>s.InsId == exist.InsId);
          if(!exist_1){
            this.selectedIns.push(exist);
            this.insIds.push(exist.InsId);
            if ( !this.options.find( s => s.InsId == exist.InsId)) {
              this.options.push(exist);
            }
          }
        }
      }
      this.$emit("getValue", this.selectedIns, function(str) {
        //传递值，无论是否验证
        console.log("清理完成");
      });
    }
  },
  methods: {
    openDialog() {
      let selectedIns = Object.assign([], this.selectedIns);
      this.$refs.insDialog.openDialog(selectedIns);
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          let query1 = query.toLowerCase();
          this.options = this.insList.filter(item => {
            return (
              item.Name.toLowerCase().indexOf(query1) > -1 ||
              item.PY.toLowerCase().indexOf(query1) > -1 ||
              item.FullPY.toLowerCase().indexOf(query1) > -1
            );
          });
          console.log("取值1：", this.options);
        }, 200);
      } else {
        this.options = this.insList;
      }
      console.log("取值：", this.options);
    },
    reset() {
      this.addBtn = false;
      this.selectedIns = [];
      this.insIds = [];
      this.$refs.insDialog.reset();
      this.$emit("getValue", this.selectedIns, function(str) {
        //传递值，无论是否验证
        console.log("清理完成");
      });
    },
    getPost(insId) {
      // 记录选中日志
      if (this.isRadio && insId) {
        this.addTemplateLogWidthInsId(insId);
      }
      if (!this.isRadio) {
        if (insId.length > this.lastSelectedInsIds.length) {
          // 选中了新项
          this.addTemplateLogWidthInsId(insId[insId.length - 1]);
        } else if (insId.length < this.lastSelectedInsIds.length) {
          // 取消了旧项
        }
        this.lastSelectedInsIds = insId;
      }
      var arr = [];
      let selectedIns = [];
      this.insList.forEach(a => {
        if (this.isRadio) {
          if (
            insId &&
            a.Type == insId.split("_")[0] &&
            a.SocialId == insId.split("_")[1]
          ) {
            arr.push(a.Name);
            selectedIns.push(a);
          }
        } else {
          insId.forEach(c => {
            if (a.Type == c.split("_")[0] && a.SocialId == c.split("_")[1]) {
              arr.push(a.Name);
              selectedIns.push(a);
            }
          });
        }
      });
      // this.userName = arr.join(",")
      this.selectedIns = selectedIns;
      // this.selectedIns.forEach(item => {
      //   item.insId = {
      //     ID: item.SocialId,
      //     Type: item.Type
      //   };
      // });
      this.$emit("getValue", this.selectedIns, function(str) {
        //传递值，无论是否验证
        console.log("清理完成");
      });
    },
    addTemplateLogWidthInsId(insId) {
      let ins = this.insList.find(_ins => {
        return (
          _ins.Type == insId.split("_")[0] &&
          _ins.SocialId == insId.split("_")[1]
        );
      });
      if (ins) {
        this.addTemplateLog(ins);
      }
    },
    addTemplateLog(ins) {
      console.log(ins);
      AddTemplateSearchLog(
        this.category,
        ins.Type,
        cookieUser.userId,
        ins.SocialId
      )
        .then(res => {
          console.log(res);
        })
        .catch(error => {
          console.log(error);
        });
    },
    assignmentInput(selectedIns) {
      //input框赋值
      if (!selectedIns) selectedIns = [];
      this.selectedIns = selectedIns;
      if (this.selectedIns.length > 0) {
        if (this.isRadio) {
          this.insIds = selectedIns[0].Type + "_" + selectedIns[0].SocialId;
        } else {
          var arr = [];
          selectedIns.forEach(a => {
            arr.push(a.Type + "_" + a.SocialId);
          });
          this.insIds = arr;
        }
      } else {
        selectedIns = [];
        this.insIds = this.isRadio ? "" : [];
        // this.idArray = [];
      }
      // this.selectedIns.forEach(item => {
      //   item.insId = {
      //     ID: item.SocialId,
      //     Type: item.Type
      //   };
      // });
      console.log("selectedIns", selectedIns);
      this.selectedIns.forEach(ins => {
        this.addTemplateLog(ins);
      });
      this.GetTemplateCompanyDeptSearchByCount();
      this.$emit("getValue", selectedIns, function(str) {
        //传递值，无论是否验证
        // isValidate = str;
      });
    },
    async getTreeData() {
      let insParas = {
        CurrentUserId: cookieUser.userId,
        Keyword: ""
      };
      await this.GetTemplateCompanyDeptSearchByResultAndCount(insParas);
    },
    async GetTemplateCompanyDeptSearchByResultAndCount(insParas) {
      let response_count = await GetTemplateCompanyDeptSearchByCount(
        cookieUser.userId
      );
      response_count.forEach(res => {
        res.InsId = res.Type + "_" + res.SocialId;
      });
      let response = await GetTemplateCompanyDeptSearchResult(insParas);
      response.forEach(res => {
        res.InsId = res.Type + "_" + res.SocialId;
      });
      this.options = response_count;
      this.insList = response;
      
      if (((this.isRadio && !this.insIds) || (!this.isRadio && this.insIds.length == 0)) 
          && this.idArray.length > 0 ) {
        this.selectedIns = [];
        if (this.isRadio) {  //单选
          let id = this.insIds || this.idArray[0];
          let inputIns = response.filter(res => res.InsId == id);
          if (inputIns && inputIns.length > 0) {
            this.selectedIns.push(inputIns[0]);
            this.insIds = inputIns[0].InsId;
            if (
              this.options.findIndex(
                ins => ins.InsId == inputIns[0].InsId
              ) < 0
            ) {
              this.options.push(inputIns[0]);
            }
          }
        } else {  //多选，处理idArray
          let ids = this.idArray;
          ids.forEach(id => {
            let exist = response.find(res => res.InsId == id);
            if (exist) {
              let exist_1  = this.selectedIns.find(s=>s.InsId == exist.InsId);
              if(!exist_1){
                this.selectedIns.push(exist);
                this.insIds.push(exist.InsId);
                if ( !this.options.find( s => s.InsId == exist.InsId)) {
                  this.options.push(exist);
                }
              }
            }
          });
          this.$emit("getValue", this.selectedIns, function(str) {
            //传递值，无论是否验证
            // isValidate = str;
          });
        }
      }
    },
    GetTemplateCompanyDeptSearchByCount() {}
  },
  async created() {
     await this.getTreeData();
  }
};
</script>

<style scoped>
.selected >>> .el-button--mini, .selected >>> .el-button--small{
    border-top-left-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 0px;
    border-left:0px;
}
    
.selected >>> .el-input__inner{
    border-radius: 0px; 
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
</style>
